import { render, staticRenderFns } from "./TabCotationConfig.vue?vue&type=template&id=24abe2a4&"
import script from "./TabCotationConfig.vue?vue&type=script&lang=js&"
export * from "./TabCotationConfig.vue?vue&type=script&lang=js&"
import style0 from "./TabCotationConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports